import styled from "styled-components";

export const TableTileTableWrapper = styled.div<{ $isWithoutHeader: boolean; }>`
    position: relative;
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
    margin-top: 9px;
`;